import type { NavigateFunction } from 'react-router';
import { createDraftDocument } from './documentContentService';
import { openWorkspaceDraftTab } from '../store/workspaceTabsStore';
import { formatWorkspaceDraftTabTitle } from './utils';
import {
  DEFAULT_LINE_SPACING,
  DEFAULT_PARAGRAPH_SPACING_PT,
} from './editor-defaults';

export type StartBlankCaseDraftOptions = {
  caseId: string;
  userId: string;
  workspaceId: string;
  caseTitle?: string;
  draftsSubTab?: 'recommended' | 'caseDrafts';
  navigate: NavigateFunction;
};

export async function startBlankCaseDraftAndOpenEditor(
  options: StartBlankCaseDraftOptions,
): Promise<string> {
  const {
    caseId,
    userId,
    workspaceId,
    caseTitle,
    draftsSubTab = 'recommended',
    navigate,
  } = options;

  const tabId = 'tab-1';
  const title = 'Untitled Draft';
  const docId = await createDraftDocument({
    title,
    tabs: [
      {
        id: tabId,
        title,
        content: '',
        paragraphSpacing: DEFAULT_PARAGRAPH_SPACING_PT,
        lineSpacing: DEFAULT_LINE_SPACING,
      },
    ],
    activeTabId: tabId,
    caseId,
    lawyerId: userId,
    workspaceId,
    documentType: 'Blank Document',
    source: 'scratch',
  });

  const path = openWorkspaceDraftTab({
    docId,
    title: formatWorkspaceDraftTabTitle(title, caseTitle),
  });
  navigate(path, {
    state: { fromCaseId: caseId, draftsSubTab },
  });

  return docId;
}
